import { ActionType, CompleteMultiTierStepPayload } from "../../AppDataProvider/actions";
import { AppContext, BookingData } from "../../AppDataProvider/AppDataProvider";
import { Button as BaseButton, List, ListItem, NavButtons } from "../../common/components";
import { getCurrencyDisplay, getFirstStep } from "../../utils";
import { marginBottom, marginTop, media, typography } from "../../common/styles";
import React, { ReactElement, useContext } from "react";
import { PartRequired } from "../../utils/types";
import { requireBookingDataFields } from "../../utils";
import { ServiceTier } from "../../AppDataProvider/AppDataProvider";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
type MultiTierStepBookingData = PartRequired<BookingData, "organisation" | "service">;
export function MultiTierStep(): ReactElement {
  const {
    t,
    i18n
  } = useTranslation();
  const {
    appData,
    appDataDispatch
  } = useContext(AppContext);
  requireBookingDataFields<MultiTierStepBookingData>(appData.bookingData, ["organisation", "service"]);
  const {
    organisation,
    service
  } = appData.bookingData;
  if (!service.tiers || !service.tiers.length) {
    console.error(`Missing required tiers on the selected service step`);
    return <>{t("errors.generic")}</>;
  }
  const tiers: ServiceTier[] = service.tiers;
  const getPriceDisplay = (tier: ServiceTier): string => {
    const prices: number[] = tier.pricePoints.map(pricePoint => pricePoint.pricePerQuantity);
    const minPrice = Math.min(...prices);
    const minPriceDisplay = minPrice === 0 ? t("free") : getCurrencyDisplay(minPrice, organisation.currency, i18n.language);
    return [...new Set(prices)].length > 1 ? t("fromValue", {
      value: minPriceDisplay
    }) : minPriceDisplay;
  };
  const selectTier = (tier: ServiceTier) => {
    const payload: CompleteMultiTierStepPayload = {
      updatedData: {
        tier
      }
    };
    appDataDispatch({
      payload,
      type: ActionType.COMPLETE_MULTI_TIER_STEP
    });
  };
  const canGoBack = getFirstStep({
    bookingData: appData.bookingData,
    bookingTool: appData.bookingTool
  }) !== "multiTier";
  const goBack = () => {
    appDataDispatch({
      type: ActionType.BACK_FROM_MULTI_TIER_STEP
    });
  };
  return <>
      <List data-sentry-element="List" data-sentry-source-file="MultiTierStep.tsx">
        {tiers && tiers.map(tier => <ListItem key={tier._id}>
              <Content>
                <Name>{tier.name}</Name>
                {tier.description && <Description>{tier.description}</Description>}
                {organisation.showPricesOnBookingTools && <Price>{getPriceDisplay(tier)}</Price>}
              </Content>

              <Button onClick={() => selectTier(tier)}>{t("select")}</Button>
            </ListItem>)}
      </List>
      {canGoBack && <NavButtons {...{
      hideContinue: true,
      onBack: goBack
    }} />}
    </>;
}
const Content = styled.div`
  display: flex;
  flex-direction: column;
`;
const Name = styled.h2`
  ${typography.subtitle}
  ${marginTop.zero}
  ${marginBottom.s}
`;
const Description = styled.div`
  ${typography.body}
  ${marginBottom.s}
`;
const Price = styled.div`
  ${typography.small}
  @media ${media.mobile} {
    ${marginBottom.s}
  }
`;
const Button = styled(BaseButton)`
  min-width: 6.25rem;
`;